export function birthYearFromDate(value) {
  if (!value) return '';
  const y = String(value).slice(0, 4);
  return /^\d{4}$/.test(y) ? y : '';
}

export function formatPatientBirthDate(value) {
  if (!value) return '';
  const d = new Date(`${String(value).slice(0, 10)}T12:00:00`);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
}

/** Возраст на указанную дату (по умолчанию — сегодня). */
export function ageFromBirthDate(value, referenceDate = new Date()) {
  if (!value) return null;
  const birth = new Date(`${String(value).slice(0, 10)}T12:00:00`);
  if (Number.isNaN(birth.getTime())) return null;

  const ref = new Date(referenceDate);
  let age = ref.getFullYear() - birth.getFullYear();
  const monthDiff = ref.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && ref.getDate() < birth.getDate())) {
    age -= 1;
  }

  return age >= 0 ? age : null;
}

/** Возраст из поля формы, иначе считается от даты рождения. */
export function resolveEditableAge(ageValue, birthDate, referenceDate = new Date()) {
  const trimmed = String(ageValue ?? '').trim();
  if (trimmed !== '') {
    const n = Number(trimmed);
    if (Number.isFinite(n) && n >= 0 && n <= 120) return Math.round(n);
  }
  return ageFromBirthDate(birthDate, referenceDate);
}

export function formatPatientAgeYears(age) {
  if (age == null || Number.isNaN(Number(age))) return '';
  const n = Number(age);
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 14) return `${n} лет`;
  if (mod10 === 1) return `${n} год`;
  if (mod10 >= 2 && mod10 <= 4) return `${n} года`;
  return `${n} лет`;
}

export function patientBirthSummary(birthDate, fallbackAge = null) {
  const formattedBirth = formatPatientBirthDate(birthDate);
  const age = ageFromBirthDate(birthDate) ?? (fallbackAge != null ? Number(fallbackAge) : null);
  const formattedAge = formatPatientAgeYears(age);

  if (formattedBirth && formattedAge) {
    return `Дата рождения: ${formattedBirth} · ${formattedAge}`;
  }
  if (formattedBirth) return `Дата рождения: ${formattedBirth}`;
  if (formattedAge) return formattedAge;
  return '';
}
